import React from 'react';
import PropTypes from 'prop-types';
import SideContent from './components/SideContent';
import TabItems from './components/TabItems';
import { classes, st } from './Tabs.st.css.js';
import { SIZE } from './Tabs.constants';
import HorizontalScroll from '../HorizontalScroll';
const Tabs = ({ dataHook, className, activeId, hasDivider = true, items, minWidth, type, size = SIZE.medium, sideContent, width, alignment, onClick, scrollOnOverflow, horizontalScrollProps, }) => {
    const tabItemsProps = {
        className,
        activeId,
        hasDivider,
        items,
        minWidth,
        type,
        size,
        width,
        alignment,
        onClick,
        scrollOnOverflow,
    };
    return (React.createElement("div", { "data-divider": hasDivider, "data-hook": dataHook, className: st(classes.container, {
            hasDivider,
            size,
            scrollOnOverflow,
        }, className) },
        scrollOnOverflow ? (React.createElement(HorizontalScroll, { ...horizontalScrollProps },
            React.createElement(TabItems, { ...tabItemsProps }))) : (React.createElement(TabItems, { ...tabItemsProps })),
        React.createElement(SideContent, { content: sideContent })));
};
Tabs.displayName = 'Tabs';
Tabs.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hasDivider: PropTypes.bool,
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        title: PropTypes.node,
        minWidth: PropTypes.number,
        maxWidth: PropTypes.number,
        dataHook: PropTypes.string,
        prefix: PropTypes.node,
        suffix: PropTypes.node,
    })).isRequired,
    minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.oneOf([
        'compact',
        'compactSide',
        'uniformSide',
        'uniformFull',
    ]),
    size: PropTypes.oneOf(['medium', 'small']),
    sideContent: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    alignment: PropTypes.oneOf(['start', 'center', 'end']),
    onClick: PropTypes.func,
    scrollOnOverflow: PropTypes.bool,
    horizontalScrollProps: PropTypes.shape(HorizontalScroll.propTypes),
};
export default Tabs;
//# sourceMappingURL=Tabs.js.map